import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { usePageMeta } from '@/hooks/usePageMeta';

const features = [
  {
    icon: 'ri-movie-2-line',
    title: '剧集资讯与剧情介绍',
    desc: '整理收录电视剧的剧情简介、角色资料与分集信息，帮助你在追剧前快速了解故事脉络。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '幕后花絮与主创动态',
    desc: '汇集片场纪实、主创专访与拍摄故事，从镜头之外看见一部剧的诞生过程。',
  },
  {
    icon: 'ri-search-line',
    title: '关键词搜索与分类筛选',
    desc: '支持按剧名、类型标签与花絮关键词检索，并结合状态、类型与更新时间快速筛选。',
  },
  {
    icon: 'ri-heart-line',
    title: '本地收藏，随时回看',
    desc: '登录前即可收藏感兴趣的剧集，收藏记录保存在你自己的浏览器中，方便下次继续浏览。',
  },
];

export default function AboutPage() {
  usePageMeta(
    '关于我们 - 我妻子的一切影视资讯站',
    '了解「我妻子的一切」影视资讯站的定位、内容板块与联系方式。本站专注电视剧资讯、剧情介绍与幕后花絮分享。',
    '关于我们,我妻子的一切,影视资讯站,内容介绍,联系方式',
  );

  return (
    <div className="mx-auto w-full max-w-site px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

      <header className="mt-5 rounded-lg bg-gradient-to-r from-primary-900 to-primary-700 px-6 py-10 md:px-10 md:py-14">
        <span className="inline-flex items-center gap-2 text-xs font-label uppercase tracking-widest text-accent-400">
          <span className="h-px w-6 bg-accent-400" />
          About Us
        </span>
        <h1 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-4xl">
          关于「我妻子的一切」影视资讯站
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-200 md:text-base">
          本站是一个以《我妻子的一切》为核心、聚焦电视剧资讯与剧情介绍的内容平台，
          面向喜欢追剧、关注影视动态的普通观众与粉丝。我们希望通过清晰的内容组织，
          让你更轻松地获取最新剧集信息、了解剧情背景与幕后故事。
        </p>
      </header>

      <section className="mt-10">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          我们提供什么
        </h2>
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {features.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-[1.3fr_1fr]">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950">网站定位与内容说明</h2>
          <div className="mt-4 space-y-4 text-sm leading-loose text-foreground-600">
            <p>
              本站专注《我妻子的一切》电视剧及其相关影视内容，内容涵盖最新剧集更新、剧情介绍、
              角色资料与幕后花絮报道，服务于影视爱好者的资讯获取与剧情了解需求。
            </p>
            <p>
              站点采用分类浏览与关键词检索相结合的方式组织内容，并通过相关推荐引导你持续发现感兴趣的作品。
              收藏功能基于浏览器本地存储实现，属于前端演示能力，不会上传或同步任何个人数据。
            </p>
            <p className="rounded-md bg-accent-50 p-4 text-accent-900">
              特别说明：本站当前所有剧集与花絮信息均为演示用虚构内容，仅用于展示页面与交互效果，
              不提供任何视频播放、资源下载或付费服务。
            </p>
          </div>
        </div>

        <div className="space-y-6">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">联系我们</h2>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line" />
                </span>
                contact@wife-of-mine.example.com
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-time-line" />
                </span>
                每日 09:00 - 22:00 更新资讯
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                <i className="ri-video-line" />
              </span>
            </div>
          </div>

          <div className="rounded-lg bg-primary-900 p-6">
            <h2 className="font-heading text-lg font-bold text-background-50">开始浏览</h2>
            <p className="mt-2 text-sm text-background-200">
              从最新剧集或热门花絮开始，探索「我妻子的一切」的故事世界。
            </p>
            <div className="mt-4 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/category/电视剧"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 font-label text-sm text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-movie-2-line" />
                浏览剧集
              </Link>
              <Link
                to="/category/花絮"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/50 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-newspaper-line" />
                浏览花絮
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
        <h2 className="font-heading text-lg font-bold text-foreground-950">版权声明与使用说明</h2>
        <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
          <li>1. 本站内容仅用于影视爱好者之间的资讯交流与页面展示，不构成任何商业推广。</li>
          <li>2. 站内剧集名称、剧情与人物信息均为演示用虚构内容，如与真实作品雷同纯属巧合。</li>
          <li>3. 本站不提供任何视频播放、资源下载、会员或支付功能，请通过正规渠道观看相关作品。</li>
          <li>4. 收藏数据仅保存在你的浏览器本地，清除浏览器数据后将无法恢复。</li>
        </ul>
        <p className="mt-6 text-xs text-foreground-400">© 2026 我妻子的一切 · 影视资讯内容站</p>
      </section>
    </div>
  );
}